export enum quoteFilterTabsList {
    FOREX = "forex",
    CRYPTO = "crypto",
    EQUITY = "equity",
    COMMODITY = "commodity",
    INDEX = "index",
    BONDS = "bonds"
}

export function quoteFilterTabsParams(): { id: string; label: string }[] {
    let tabsParams: { id: string; label: string }[] = [
        { id: quoteFilterTabsList.FOREX, label: "Forex" },
        { id: quoteFilterTabsList.CRYPTO, label: "Crypto" },
        { id: quoteFilterTabsList.EQUITY, label: "Equity" },
        { id: quoteFilterTabsList.COMMODITY, label: "Commodity" },
        { id: quoteFilterTabsList.INDEX, label: "Index" },
        { id: quoteFilterTabsList.BONDS, label: "Bonds" }
    ];
    return tabsParams;
}

export function quoteFilterTabsParamsOanda(): { id: string; label: string }[] {
    let tabsParams: { id: string; label: string }[] = [
        { id: quoteFilterTabsList.FOREX, label: "Forex" }
        // { "id": quoteFilterTabsList.CRYPTO, "label": "Crypto" },
        // { "id": quoteFilterTabsList.EQUITY, "label": "Equity" },
        // { "id": quoteFilterTabsList.COMMODITY, "label": "Commodity" },
        // { "id": quoteFilterTabsList.INDEX, "label": "Index" },
        // { "id": quoteFilterTabsList.BONDS, "label": "Bonds" },
    ];
    return tabsParams;
}

export function quoteFilterTabsParamsMobile(): { id: string; label: string }[] {
    let tabsParams: { id: string; label: string }[] = [
        { id: quoteFilterTabsList.FOREX, label: "Forex" },
        { id: quoteFilterTabsList.CRYPTO, label: "Crypto" },
        { id: quoteFilterTabsList.EQUITY, label: "Equity" },
        { id: quoteFilterTabsList.COMMODITY, label: "Comdty" },
        { id: quoteFilterTabsList.INDEX, label: "Index" },
        { id: quoteFilterTabsList.BONDS, label: "Bonds" }
    ];
    return tabsParams;
}

export function getquoteFilterTabsList(): string[][] {
    let res: string[][] = [];
    for (const n in quoteFilterTabsList) {
        if (quoteFilterTabsList.hasOwnProperty(n)) {
            res.push([n, (<any>quoteFilterTabsList)[n]]);
        }
    }
    return res;
}
